<template>
  <div>
    <b-container class="mt-5 mb-5">
      <div class="mb-2 clearfix">
        <h1 class="fs-4 font-weight-bold mb-0">Nieuw ticket</h1>
      </div>
      <EventCanceledAlert :event="event" />
      <ValidationObserver ref="form" slim>
        <b-card>
          <EventTicket :event="event" :ticket="ticket" />
        </b-card>
        <template v-if="!event.canceled_at">
          <div class="mt-3 clearfix">
            <b-button
              @click="submitForm()"
              variant="primary"
              class="float-right"
            >
              Opslaan
              <font-awesome-icon icon="fa-solid fa-chevron-right ml-2" />
            </b-button>
          </div>
        </template>
      </ValidationObserver>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";

import EventTicket from "@/components/event/EventTicket.vue";
import EventCanceledAlert from "@/components/event/EventCanceledAlert";

export default {
  metaInfo: {
    title: "Nieuw ticket",
  },
  components: {
    EventCanceledAlert,
    ValidationObserver,
    EventTicket,
  },
  data() {
    return {
      ticket: {
        type: null,
        name: null,
        description: null,
        price: null,
        amount_available: null,
        extra_information: null,
        header_image: null,
        is_custom_sell_date: false,
        start_sale_at_date: null,
        start_sale_at_time: null,
        end_sale_at_date: null,
        end_sale_at_time: null,
        is_multiday_ticket: false,
        is_custom_valid_date: false,
        start_valid_at_date: null,
        start_valid_at_time: null,
        end_valid_at_date: null,
        end_valid_at_time: null,
      },
      event: {},
    };
  },
  computed: {},
  methods: {
    async submitForm() {
      let check = await this.$refs["form"].validate();

      if (!check) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        return;
      }

      this.$axios
        .post(
          "https://api.tixgo.nl/events/" + this.$route.params.id + "/tickets",
          this.ticket,
        )
        .then((response) => {
          response;
          this.$router.push(
            "/manage/events/" + this.$route.params.id + "/settings/tickets",
          );
        });
    },
    fetchEvent: function () {
      this.$axios
        .get("https://api.tixgo.nl/events/" + this.$route.params.id)
        .then((response) => {
          this.event = response.data;
        })
        .catch((reason) => {
          console.log(reason);
        });
    },
  },
  created() {
    this.fetchEvent();
  },
};
</script>
